import PropTypes from 'prop-types'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import { getFormattedAdPrice } from 'SRC/utils'

export const Price = ({ price, priceWithDiscount, showDiscount }) => {
  const { t } = useTranslation('common')

  return (
    <div className='price-container'>
      {Number(price) ? (
        <div className='price'>
          <p>{getFormattedAdPrice(priceWithDiscount || price)} &euro;</p>
        </div>
      ) : null}

      {priceWithDiscount && price && showDiscount ? (
        <span className='price-old-price'>{getFormattedAdPrice(price)} &euro;</span>
      ) : null}
    </div >
  )
}

Price.propTypes = {
  price: PropTypes.number.isRequired,
  oldPrice: PropTypes.number,
}


